// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"b94f727b","459":"fe678362","774":"93d11a19","791":"e525816d","835":"9946950e"}[chunkId] + ".chunk.js";
};